// extracted by mini-css-extract-plugin
module.exports = {"contentChanger":"ContentChanger_contentChanger__2VEle","header":"ContentChanger_header__2HZcT"};